export default __webpack_public_path__ + "static/icons-sprite-223c412724db54b22b27a32ed789e4fe.svg";